import { COLORS } from '@/styles'

export const DEFAULT_THEME_COLORS = {
  PRIMARY: COLORS.BLACK,
  SECONDARY: COLORS.WARM_IVORY,
  TEXT: COLORS.WHITE,
}
